import { toJS } from "mobx";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import PDFICON from "../../../src/assets/Home/PDFICON.svg";

type Obj = {
  [key: string]: any;
};

interface MobileDataGridProps {
  rows: Obj[];
  indexes: any;
  downloadBillPDF: any;
  downloadPaymentHistoryPdf: any;
  downloadAccountSummaryPdf: any;
  downloadPDCFile: any;
  handleAmountToPay?: (index: number, value: string) => void;
  handleRowSelection?: (ids: any) => void;
  amountToPayArray?: any[];
  selectedRows?: any[];
  checkboxSelection?: boolean;
}

const MobileDataGrid: React.FC<MobileDataGridProps> = ({
  rows,
  indexes,
  downloadBillPDF,
  downloadPaymentHistoryPdf,
  downloadAccountSummaryPdf,
  downloadPDCFile,
  handleAmountToPay,
  handleRowSelection,
  amountToPayArray = [],
  selectedRows = [],
  checkboxSelection = false,
}) => {
  const contrast = General?.contrast;

  // Your component logic here
  return (
    <div
      className="px-3 "
      style={{
        height: "20rem",
        overflowY: "scroll",
        backgroundColor: "white",
        position: "relative",
      }}
    >
      {indexes === 0 && (
          <div>
            {rows.map((row, index) => {
              const isSelected = selectedRows?.some((r) => r?.id === row.id);
              const amountToPayObj = amountToPayArray?.find((item) => item.id === row.id);
              return (
            <div className="row gy-3 align-items-start" key={row.id || index}>
          {/* Account Number + checkbox (checkbox moved inline here) */}
          <div className="col-1  ">
              {checkboxSelection && (
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => {
                  if (handleRowSelection) {
                    const ids = isSelected
                      ? selectedRows.filter((r) => r?.id !== row.id).map((r) => r.id)
                      : [...(selectedRows?.map((r) => r.id) || []), row.id];
                    handleRowSelection(ids);
                  }
                }}
                aria-label={`Select account ${row.accountNumber}`}
                style={{ marginRight: 8, marginTop: 6 }}
              />
            )}
          </div>
        <div className="col-11">   
    <div className="row">
          <div className="col-4 col-md-2 order-1 d-flex">
           

            <div>
              <p className="mb-1 account-grid-mobile-heading" style={{
                fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor || "",
              }}>
                {General?.codeLabels["cm_accountnopaymentstable"]?.label || "Account Number"}
              </p>
              <p className="mb-1 account-grid-mobile-text" style={{
                fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor || "",
              }}>
                {row.accountNumber}
              </p>
            </div>
          </div>

          {/* Sewerage Number */}
          <div className="col-4 col-md-2 order-2">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_seweragenum"]?.label || "Sewerage Number"}
            </p>
            <p className="mb-0 account-grid-mobile-text" style={{
              fontSize: `${0.6 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {row.sewerageNumber}
            </p>
          </div>

          {/* Premise Details */}
          <div className="col-4 col-md-3 order-3">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_pdc_premisedetails"]?.label || "Premise Details"}
            </p>
            <p className="mb-0 account-grid-mobile-text" style={{
              fontSize: `${0.6 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {row.premiseDetails}
            </p>
          </div>
          {/* Premise Type */}
          <div className="col-4 col-md-2 order-4">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_premise_type"]?.label || "Premise Type"}
            </p>
            <p className="mb-1 account-grid-mobile-text" style={{
              fontSize: `${0.6 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {row.premiseType}
            </p>
          </div>

          {/* Type */}
          <div className="col-4 col-md-1 order-5">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_type"]?.label || "Type"}
            </p>
            <p className="mb-1 account-grid-mobile-text" style={{
              fontSize: `${0.6 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {row.type}
            </p>
          </div>

          {/* Amount Due */}
          <div className="col-4 col-md-1 order-6">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_amt_due"]?.label || "Amount Due"}
            </p>
            <p className="mb-1 account-grid-mobile-text" style={{
              fontSize: `${0.6 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {row.amountDue}
            </p>
          </div>
   </div>

    <div className="row">
      <div className="col-12 col-md-2 order-12">
            <p className="mb-1 account-grid-mobile-heading" style={{
              fontSize: `${0.75 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor || "",
            }}>
              {General?.codeLabels["cm_amttopay"]?.label || "Amount To Pay"}
            </p>
            {handleAmountToPay ? (
              <input
                type="number"
                value={amountToPayObj?.amountTopay ?? row.amountToPay ?? row.amountDue ?? ""}
                onChange={(e) => handleAmountToPay(row.id, e.target.value)}
                className="form-control"
                min={0}
              />
            ) : (
              <p className="mb-1 account-grid-mobile-text" style={{
                fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor || "",
              }}>
                {row.amountToPay || row.amountToPay === 0 ? row.amountToPay : row.amountDue}
              </p>
            )}
          </div>
    </div>

          {/* Amount To Pay (always last) */}
          
          </div>

          <div className="col-12">
            <hr className="mt-3" />
          </div>
        </div>


              );
            })}
          </div>
)}

      {indexes === 1 && (
        <div>
          {rows.map((rows, index) => {
            console.log(
              "🚀 ~ file: MobileDataGrid.tsx:301 ~ {rows.map ~ rows:",
              toJS(rows)
            );

            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_billdatedatatable"]?.label ? General?.codeLabels["cm_billdatedatatable"]?.label : "Bill Date"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.paymentDate}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pdc_premisedetails"]?.label
                        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
                        : "Premise Details"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.premiseDetails}{" "}
                    </p>
                  </div>
                  
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_billeventidtable"]?.label ? General?.codeLabels["cm_billeventidtable"]?.label : "Bill Reference"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentReference}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_noccustomername"]?.label
                        ? General?.codeLabels["cm_noccustomername"]?.label
                        : "Customer Name"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.customerName}{" "}
                    </p>
                  </div>
                  <div className=""></div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_accountnopaymentstable"]?.label
                        ? General?.codeLabels["cm_accountnopaymentstable"]
                            ?.label
                        : "Account Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_bill"]?.label
                        ? General?.codeLabels["cm_bill"]?.label
                        : "Bill"}
                    </p>
                    <div className="">
                      <img
                        src={PDFICON}
                        onClick={() => downloadBillPDF(rows.paymentReference)}
                        alt="pdf"
                      />
                    </div>
                    {/* <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pay_status"]?.label
                        ? General?.codeLabels["cm_pay_status"]?.label
                        : "Payment Status"}
                    </p> */}
                    {/* <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentStatus}{" "}
                    </p> */}
                  </div>
                  <div className=""></div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}
      {indexes === 2 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_paymentdatedatatable"]?.label
                        ? General?.codeLabels["cm_paymentdatedatatable"]?.label
                        : "Payment Date"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.paymentDate}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pdc_premisedetails"]?.label
                        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
                        : "Premise Details"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.premiseDetails}{" "}
                    </p>
                  </div>
                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_receipt"]?.label
                        ? General?.codeLabels["cm_receipt"]?.label
                        : "Receipt"}
                    </p>
                    <div className="">
                      <img src={PDFICON} 
                       onClick={() => downloadPaymentHistoryPdf(rows.paymentReference)}
                       alt="pdf" />
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_payment_referenceno"]?.label
                        ? General?.codeLabels["cm_payment_referenceno"]?.label
                        : "Payment Reference"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentReference}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_noccustomername"]?.label
                        ? General?.codeLabels["cm_noccustomername"]?.label
                        : "Customer Name"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.customerName}{" "}
                    </p>
                  </div>
                  <div className="">
                    {/* <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_accountnopaymentstable"]?.label
                    ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                    : "Account Number"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {rows.accountNumber}{" "}
                </p> */}
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_accountnopaymentstable"]?.label
                        ? General?.codeLabels["cm_accountnopaymentstable"]
                            ?.label
                        : "Account Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_paid_am"]?.label
                        ? General?.codeLabels["cm_paid_am"]?.label
                        : "Paid Amount"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentReference}{" "}
                    </p>
                  </div>
                  <div className="">
                    {/* <p
                  className="mb-0 account-grid-mobile-heading"
                  style={{
                    fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_accountnopaymentstable"]?.label
                    ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                    : "Account Number"}
                </p>
                <p
                  className="mb-0 account-grid-mobile-text"
                  style={{
                    fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    lineHeight: "23px",
                  }}
                >
                  {" "}
                  {rows.accountNumber}{" "}
                </p> */}
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}

      {indexes === 3 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_accountnopaymentstable"]?.label
                        ? General?.codeLabels["cm_accountnopaymentstable"]
                            ?.label
                        : "Account Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.accountNumber}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      createdDate
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.createdDate}{" "}
                    </p>
                  </div>
                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Bank Name / Account
                    </p>

                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.bankNameAccount}{" "}
                    </p>
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_seweragenum"]?.label
                        ? General?.codeLabels["cm_seweragenum"]?.label
                        : "Sewerage Number"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.sewerageNumber}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Chq Date
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.chqDate}{" "}
                    </p>
                  </div>
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Chq Amount
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.chqAmount}{" "}
                    </p>
                  </div>
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Receipt
                    </p>

                      <img src={PDFICON} 
                      onClick={() => downloadPDCFile(rows.ppId, 'PDC')}                        
                      alt="pdf" />
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pdc_premisedetails"]?.label
                        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
                        : "Premise Details"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.premiseDetails}{" "}
                    </p>
                  </div>

                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Chq Number
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.chqNumber}{" "}
                    </p>
                  </div>
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_pdc_status"]?.label
                        ? General?.codeLabels["cm_pdc_status"]?.label
                        : "Status"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.status}{" "}
                    </p>
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}

      {indexes === 4 && (
        <div>
          {rows.map((rows, index) => {
            return (
              <div className=" row d-flex justify-content-between my-3">
                <div className="col-4 py-1">
                  <div>
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {General?.codeLabels["cm_asreqdatedatatable"]?.label
                        ? General?.codeLabels["cm_asreqdatedatatable"]?.label
                        : "Creation Date"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        lineHeight: "23px",
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      {" "}
                      {rows.paymentDate}{" "}
                    </p>
                  </div>

                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_report_id"]?.label
                        ? General?.codeLabels["cm_report_id"]?.label
                        : "Report Id"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.reportId}{" "}
                    </p>
                  </div>
                  <div className="py-1">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Download File
                    </p>
                    <div className="">
                      <img src={PDFICON} 
                       onClick={() => downloadAccountSummaryPdf(rows.paymentReference)}
                       alt="pdf" />
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_type"]?.label
                        ? General?.codeLabels["cm_type"]?.label
                        : "Type"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.type}{" "}
                    </p>
                  </div>

                  <div className="">
                    {/* <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_noccustomername"]?.label
                        ? General?.codeLabels["cm_noccustomername"]?.label
                        : "Customer Name"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.customerName}{" "}
                    </p> */}
                  </div>
                  <div className="">
                    {/* <p
                className="mb-0 account-grid-mobile-heading"
                style={{
                  fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {General?.codeLabels["cm_accountnopaymentstable"]?.label
                  ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                  : "Account Number"}
              </p>
              <p
                className="mb-0 account-grid-mobile-text"
                style={{
                  fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {rows.accountNumber}{" "}
              </p> */}
                  </div>
                </div>

                <div className="col-4">
                  <div className="">
                    <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      Status
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentStatus}{" "}
                    </p>
                  </div>

                  <div className="">
                    {/* <p
                      className="mb-0 account-grid-mobile-heading"
                      style={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {General?.codeLabels["cm_paid_am"]?.label
                        ? General?.codeLabels["cm_paid_am"]?.label
                        : "Paid Amount"}
                    </p>
                    <p
                      className="mb-0 account-grid-mobile-text"
                      style={{
                        fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        lineHeight: "23px",
                      }}
                    >
                      {" "}
                      {rows.paymentReference}{" "}
                    </p> */}
                  </div>
                  <div className="">
                    {/* <p
                className="mb-0 account-grid-mobile-heading"
                style={{
                  fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {General?.codeLabels["cm_accountnopaymentstable"]?.label
                  ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                  : "Account Number"}
              </p>
              <p
                className="mb-0 account-grid-mobile-text"
                style={{
                  fontSize: `${0.6 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  lineHeight: "23px",
                }}
              >
                {" "}
                {rows.accountNumber}{" "}
              </p> */}
                  </div>
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default observer(MobileDataGrid);
